<template>
	<section class="background-div" v-bind:class="!isMobile ? 'justify-center' : 'justify-top'">
		<div class="card-container" v-bind:class="!isMobile ? 'card-container-desktop' : ''">
			<div>
				<div>
					<div class="card card-info card-dark">
						<div class="card-header text-center">
							<h4 class="m-0">Redefinir senha</h4>
						</div>
						<div class="card-body">
							<b-form @submit.prevent="sendEmail">
								<div>
									<b-form-input
										id="email"
										v-model="email"
										class="form-control input-sm chat-input"
										placeholder="Digite seu e-mail"
									/>
								</div>
                                <br>
								<div class="text-center">
									<button
										type="submit"
										class="btn-primary w-100"
										:disabled="!email"
									>
										Enviar
									</button>
								</div>
								<div
									v-if="sended"
									style="display: flex; align-items: center; justify-content: center; margin-top: -2.2rem; margin-bottom: 0.2rem; color: blue"
								>
									<div class="spinner-border" role="status"/>
								</div>
							</b-form>
						</div>
						<div class="text-center mt-2" style="border-top: 1px solid rgba(0, 0, 0, 0.125); width: 100%; position: relative; top: -12px; padding: 12px 0 6px;">
							<span @click="$router.push({ path: '/'});" style="cursor: pointer; color: white">Fazer login</span>
						</div>
					</div>
					<div class="login-msg" v-if="success || error">
						<span v-if="success" class="success-msg">
							{{ info }}
						</span>
						<span v-else-if="error" class="error-msg">
							{{ error }}
						</span>
						<br v-else>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
	.login-msg {
		text-align: center;
		padding-top: 0.5rem;
	}

	.error-msg {
		color: red;
	}

	.success-msg {
		color: #008000;
	}
</style>

<script>
	import { AuthService } from "@/services/auth";

	export default {
		data () {
			return {
				email: "",
				error: "",
				info: "",
				success: false,
				authService: new AuthService,
				backgroundImageUrl: "../assets/img/background.png",
				isMobile: false,
				sended: false
			};
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 600;
			},

			async sendEmail () {
				try {
					if (!this.email) return;
					this.sended = true;
					this.error = "";
					this.info = "Enviados dados...";
					this.success = true;
					const response = await this.authService.forget({ email: this.email });
					this.email = "";
					this.sended = false;
					if (response && response === "OK") {
						this.info = "Sucesso...";
						await this.$swal.fire({
							title: "Redefinir senha",
							text: "Enviamos um e-mail com um link para redefinir sua senha. Verifique sua caixa de entrada e também a pasta de spam.",
							type: "success"
						});
						this.$router.replace(this.$route.params.next || "/Login");
					}
				} catch (error) {
					this.sended = false;
					this.success = false;
					this.error = error?.response?.data?.message || "Erro desconhecido, por favor tente novamente.";
				}
			}
		}
	};
</script>
